import { EventType, RelationType } from 'matrix-js-sdk/lib/@types/event.js';
import { normalizeCallIntent, toCallNotificationType, } from './callIntent.js';
export const RTC_NOTIFICATION_EVENT_TYPE = EventType.RTCNotification;
export const RTC_DECLINE_EVENT_TYPE = EventType.RTCDecline;
export const REFERENCE_REL_TYPE = RelationType.Reference;
const isObject = (value) => typeof value === 'object' && value !== null;
const isMentioned = (mentions, myUserId) => {
    if (!mentions)
        return false;
    if (mentions.room)
        return true;
    return Array.isArray(mentions.user_ids) && mentions.user_ids.includes(myUserId);
};
const getSenderTimestamp = (contentTs, originTs) => contentTs - originTs > 20_000 ? originTs : contentTs;
export const parseIncomingRtcNotification = async (event, options) => {
    if (!event.isLiveEvent)
        return undefined;
    if (event.type !== RTC_NOTIFICATION_EVENT_TYPE)
        return undefined;
    if (event.sender === options.myUserId)
        return undefined;
    if (event.relation?.rel_type !== REFERENCE_REL_TYPE || !event.relation.event_id)
        return undefined;
    const rawContent = event.isEncrypted ? await options.decryptContent?.() : event.content;
    if (!isObject(rawContent))
        return undefined;
    const content = rawContent;
    if (!isMentioned(content['m.mentions'], options.myUserId))
        return undefined;
    const senderTsCandidate = content.sender_ts;
    const lifetimeCandidate = content.lifetime;
    const notificationType = toCallNotificationType(content.notification_type);
    if (typeof senderTsCandidate !== 'number')
        return undefined;
    if (typeof lifetimeCandidate !== 'number' || !Number.isFinite(lifetimeCandidate))
        return undefined;
    if (!notificationType)
        return undefined;
    const senderTs = getSenderTimestamp(senderTsCandidate, event.originServerTs);
    const lifetime = Math.min(lifetimeCandidate, options.maxLifetimeMs ?? 120_000);
    const expiresAt = senderTs + lifetime;
    if (options.now >= expiresAt)
        return undefined;
    const intentRaw = typeof content['m.call.intent'] === 'string' ? content['m.call.intent'] : undefined;
    return {
        roomId: event.roomId,
        notificationEventId: event.eventId,
        refEventId: event.relation.event_id,
        senderId: event.sender,
        senderTs,
        expiresAt,
        notificationType,
        intentKind: normalizeCallIntent(undefined, intentRaw),
        intentRaw,
    };
};
export const parseRtcDecline = (event, options) => {
    if (!event.isLiveEvent)
        return undefined;
    if (event.type !== RTC_DECLINE_EVENT_TYPE)
        return undefined;
    if (event.sender === options.myUserId)
        return undefined;
    if (event.relation?.rel_type !== REFERENCE_REL_TYPE || !event.relation.event_id) {
        return undefined;
    }
    return {
        roomId: event.roomId,
        declineEventId: event.eventId,
        notificationEventId: event.relation.event_id,
        senderId: event.sender,
    };
};
//# sourceMappingURL=rtcNotificationParser.js.map